import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Product } from '@features/trend-research/components/details/components';
import ProductTopSection from '@features/trend-research/components/details/Fabric/ProductTopSection';
import { getMultiplyWith, getQueryParamForDetails, sourceType } from '@features/trend-research/utils/utils';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findTrendResearchProductsBySource } from '@services/trendResearch';

const SimilarProducts = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [similarProducts, setSimilarProducts] = useState([]);
	const [totalElement, seTotalElement] = useState(0);
	const [page, setPage] = useState(0);

	const selectedItem = JSON.parse(sessionStorage.getItem('selectedItem')) || {};
	let queryParam = selectedItem ? getQueryParamForDetails(selectedItem) : '';

	const fetchProducts = async (offset = 0) => {
		try {
			if (!selectedItem?.source) {
				return;
			}

			dispatch(openLoader());
			const response = await findTrendResearchProductsBySource(
				sourceType[selectedItem?.source],
				queryParam + `&page=${offset}&size=20`
			);
			if (!response.data.length) {
				dispatch(closeLoader());
				return;
			}

			//setSimilarProducts(response.data);
			setSimilarProducts((prevProducts) => [...prevProducts, ...response.data]);
			seTotalElement(response.totalElements);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};
	useEffect(() => {
		if (queryParam !== '') {
			fetchProducts(page);
			navigate({
				state: { source: selectedItem?.source || '' }
			});
		}
	}, [queryParam, page]);

	const handleScroll = async () => {
		if (
			window.innerHeight + document.documentElement.scrollTop + 1 >=
			document.documentElement.scrollHeight
		) {
			setPage((prev) => prev + 1);
		}
	};
	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<>
			<div className="top-header ">
				{/* <!-- Filter Contanier top--> */}
				<div className="trend-list">
					<div className="page-title-area pb-2 d-flex align-items-center">
						<div className="d-flex">
							<h1 className="semibold-16">Similar styles</h1>
						</div>
					</div>
				</div>
			</div>
			{/* <!--Data container --> */}
			<section className="trend-data-container bg-white">
				<div className="similar-category-section">
					<div
						className="similar-product-box d-flex align-items-center align-self-center"
						style={{
							minWidth: `${
								300 + selectedItem?.name?.length * getMultiplyWith(selectedItem?.name?.length)
							}px`
						}}
					>
						<div className="img">
							<img
								src={
									selectedItem?.imageUrl ||
									`${process.env.PUBLIC_URL}/images/trend/demo.jpg`
								}
								alt=""
							/>
						</div>
						<div className="similar-content ml-12">
							<p className="gray_dark_01 regular-14 weight-500 p-0">{selectedItem?.name}</p>
							<ul className="common-list-component mt-1">
								<li className="gray_dark_01 regular-14 weight-500">
									{selectedItem?.brandName || ''}
								</li>
								<li className="gray_dark_01 regular-14 weight-500">{selectedItem?.market}</li>
							</ul>
							<p className="ray_dark_01 regular-12 p-0">Related Products</p>
						</div>
					</div>
				</div>
				{/* <!-- trend-product --> */}
				<div className="trending-product border-0 top-fabric-product">
					<ProductTopSection title={`Similar Products(${totalElement})`} />
					<Product allProducts={similarProducts} selectedItem={selectedItem} />
				</div>
			</section>
		</>
	);
};

export default SimilarProducts;
